import React from 'react';
import {render} from 'react-dom';
import App from './app/DrumallApp';

import {loadPolyfills} from './app/polyfills';

const run = async () => {
    
    const mountNode = document.querySelector('#mallfront-root');
    
    render(<App initialMessages={{}} />, mountNode);
};

loadPolyfills().then(() => {
    run();
}).catch(err => console.log(err));
